import { ContactFormData } from "@app/types/forms";

export const FORM_IDS = {
  en: "49a6c548-058e-47e4-977f-7bedfd5ccc5d",
  de: "9b1921bb-40ee-47b7-ad86-e213a0584a23",
  it: "4c698ff5-50dc-47ee-8701-c70d4e57cc01",
  fr: "2a391190-136e-44a1-a6d8-0ed83c967cc3",
};

export const INITIAL_VALUES: ContactFormData = {
  isCustomer: false,
  firstName: "",
  lastName: "",
  email: "",
  phoneCode: {
    alphaCode: "CH",
    code: "41",
  },
  phone: "",
  howDidYouHear: "",
  message: "",
  isSwissResidentConfirmed: false,
  isPrivacyPolicyConfirmed: false,
};

export const RECAPTCHA_ACTION = "contact";
export const UNDEFINED_VALUE = "undefined";
export const EXISTING_CUSTOMER = "existing customer";
export const TRUE = "yes";
export const FALSE = "no";
